import { Handing } from '../__generated/model/index.js';
export const NO_HANDING = 'none';
export const NO_VARIANT = 'none';
export var CabinetWidth;
(function(CabinetWidth) {
    CabinetWidth[CabinetWidth["W0"] = 0] = "W0";
    CabinetWidth[CabinetWidth["W1"] = 25.4] = "W1";
    CabinetWidth[CabinetWidth["W1_25"] = 31.75] = "W1_25";
    CabinetWidth[CabinetWidth["W1_5"] = 38.1] = "W1_5";
    CabinetWidth[CabinetWidth["W1_75"] = 44.45] = "W1_75";
    CabinetWidth[CabinetWidth["W2"] = 50.8] = "W2";
    CabinetWidth[CabinetWidth["W2_25"] = 57.15] = "W2_25";
    CabinetWidth[CabinetWidth["W2_5"] = 63.5] = "W2_5";
    CabinetWidth[CabinetWidth["W2_75"] = 69.85] = "W2_75";
    CabinetWidth[CabinetWidth["W3"] = 76.2] = "W3";
    CabinetWidth[CabinetWidth["W3_25"] = 82.55] = "W3_25";
    CabinetWidth[CabinetWidth["W3_5"] = 88.9] = "W3_5";
    CabinetWidth[CabinetWidth["W3_75"] = 95.25] = "W3_75";
    CabinetWidth[CabinetWidth["W4"] = 101.6] = "W4";
    CabinetWidth[CabinetWidth["W4_25"] = 107.95] = "W4_25";
    CabinetWidth[CabinetWidth["W4_5"] = 114.3] = "W4_5";
    CabinetWidth[CabinetWidth["W4_75"] = 120.65] = "W4_75";
    CabinetWidth[CabinetWidth["W5"] = 127] = "W5";
    CabinetWidth[CabinetWidth["W6"] = 152.4] = "W6";
    CabinetWidth[CabinetWidth["W12"] = 304.8] = "W12";
    CabinetWidth[CabinetWidth["W18"] = 457.2] = "W18";
    CabinetWidth[CabinetWidth["W24"] = 609.6] = "W24";
    CabinetWidth[CabinetWidth["W28_25"] = 717.55] = "W28_25";
    CabinetWidth[CabinetWidth["W29_25"] = 742.95] = "W29_25";
    CabinetWidth[CabinetWidth["W30"] = 762] = "W30";
    CabinetWidth[CabinetWidth["W36"] = 914.4] = "W36";
    CabinetWidth[CabinetWidth["W42"] = 1066.8] = "W42";
    CabinetWidth[CabinetWidth["W48"] = 1219.2] = "W48";
    CabinetWidth[CabinetWidth["W54"] = 1371.6] = "W54";
    CabinetWidth[CabinetWidth["W60"] = 1524] = "W60";
    CabinetWidth[CabinetWidth["W66"] = 1676.4] = "W66";
    CabinetWidth[CabinetWidth["W72"] = 1828.8] = "W72";
    CabinetWidth[CabinetWidth["W78"] = 1981.2] = "W78";
    CabinetWidth[CabinetWidth["W84"] = 2133.6] = "W84";
    CabinetWidth[CabinetWidth["W90"] = 2286] = "W90";
    CabinetWidth[CabinetWidth["W96"] = 2438.4] = "W96";
})(CabinetWidth || (CabinetWidth = {}));
export const adjustableDoorHandingOptions = [
    {
        label: {
            id: "handing.left",
            message: "Left"
        },
        value: Handing.left
    },
    {
        label: {
            id: "handing.right",
            message: "Right"
        },
        value: Handing.right
    }
];

//# sourceMappingURL=common.js.map